export default "__VITE_ASSET__adddb063__"